import fm from 'format-message';
import PropTypes from 'prop-types';
import textStyles from 'config/branding/textStyles';
import SpinnerIcon from '@activebrands/core-web/components/icons/SpinnerIcon';
import { styled } from '@activebrands/core-web/libs/styletron';
import Checkbox from 'components/inputs/CheckboxInput';

const Wrapper = styled('button', ({ $active, $loading }) => ({
    alignItems: 'center',
    backgroundColor: $active ? 'var(--color-bg-checkout-act-vouchers-active)' : 'var(--color-bg-checkout-act-vouchers)',
    border: $active
        ? '1px solid var(--color-border-checkout-act-vouchers-active)'
        : '1px solid var(--color-border-checkout-act-vouchers)',
    borderRadius: '8px',
    color: $active ? 'var(--color-text-checkout-act-vouchers-active)' : 'var(--color-text-checkout-act-vouchers)',
    cursor: $loading ? 'default' : 'pointer',
    display: 'flex',
    opacity: $loading ? '0.5' : '1',
    padding: '8px 12px',
    pointerEvents: $loading ? 'none' : 'initial',
    position: 'relative',
    transition: 'all var(--transition-primary) var(--ease)',
}));

const LoadingWrapper = styled('div', {
    left: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
});

const Column = styled('div', {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    textAlign: 'left',
});

const Label = styled('p', {
    dislay: 'block',
    marginBottom: '4px',
    whiteSpace: 'nowrap',
    width: '100%',
    ...textStyles['Misc/14_110_-0175'],
});

const Text = styled('p', {
    color: 'var(--color-text-checkout-subtle)',
    dislay: 'block',
    whiteSpace: 'nowrap',
    width: '100%',
    ...textStyles['Misc/10_100_-00625'],
});

const ActBonusVoucher = ({ data, active = false, loading = false, handleClick, ...rest }) => {
    const name = `${data.name} - ${fm('Bonus voucher')}`;

    return (
        <Wrapper
            $active={active}
            $loading={loading}
            title={name}
            type="button"
            onClick={() => {
                handleClick(data);
            }}
            {...rest}
        >
            {loading && (
                <LoadingWrapper>
                    <SpinnerIcon height="30px" width="30px" />
                </LoadingWrapper>
            )}
            <Column $style={{ marginRight: '4px' }}>
                <Checkbox $style={{ pointerEvents: 'none' }} defaultValue={active} />
            </Column>
            <Column $style={{ minWidth: '192px' }}>
                <Label>{name}</Label>
                <Text
                    $style={{
                        color: active
                            ? 'var(--color-text-checkout-act-vouchers-active)'
                            : 'var(--color-text-checkout-act-vouchers)',
                    }}
                >
                    {fm('Expires on')}: {data?.expiresOn?.substring(0, 10)}
                </Text>
            </Column>
        </Wrapper>
    );
};

ActBonusVoucher.propTypes = {
    active: PropTypes.bool,
    data: PropTypes.shape({
        expiresOn: PropTypes.string,
        name: PropTypes.string,
    }),
    handleClick: PropTypes.func,
    loading: PropTypes.bool,
};

export default ActBonusVoucher;
